import whyChooseIcon1 from './Images/why-choose-icon-1.png'
import whyChooseIcon2 from './Images/why-choose-icon-2.png'
import whyChooseIcon3 from './Images/why-choose-icon-3.png'
import whyChooseIcon4 from './Images/why-choose-icon-4.png'

import applicationImg1 from './Images/application-1.webp'
import applicationImg2 from './Images/application-2.webp'
import applicationImg3 from './Images/application-3.webp'
import applicationImg4 from './Images/application-4.webp'
import applicationImg5 from './Images/application-5.webp'

import qualityIcon1 from './Images/home-about-icon-1.png'
import qualityIcon2 from './Images/home-about-icon-2.png'
import qualityIcon3 from './Images/home-about-icon-3.png'

import testimonialImg1 from './Images/testimonial-1.webp'
import testimonialImg2 from './Images/testimonial-2.webp'
import testimonialImg3 from './Images/testimonial-3.webp'

import gripBondImg from './Images/grip-bond.webp'
import proBondImg from './Images/pro-bond.webp'
import ultraBondImg from './Images/ultra-bond.webp'

import gripMain from './Images/product-grip-bond.webp'
import proMain from './Images/product-pro-bond.webp'
import ultraMain from './Images/product-ultra-bond.webp'

import gripSmall from './Images/grip-bond-small.webp'
import gripSide1Small from './Images/grip-1-small.webp'
import gripSide2Small from './Images/grip-2-small.webp'
import gripSide3Small from './Images/grip-3-small.webp'
import grip1Big from './Images/grip-1.webp'
import grip2Big from './Images/grip-2.webp'
import grip3Big from './Images/grip-3.webp'

import proSmall from './Images/pro-bond-small.webp'
import proSide1Small from './Images/pro-1-small.webp'
import proSide2Small from './Images/pro-2-small.webp'
import proSide3Small from './Images/pro-3-small.webp'
import pro1Big from './Images/pro-1.webp'
import pro2Big from './Images/pro-2.webp'
import pro3Big from './Images/pro-3.webp'

import ultraSmall from './Images/ultra-bond-small.webp'
import ultraSide1Small from './Images/ultra-1-small.webp'
import ultraSide2Small from './Images/ultra-2-small.webp'
import ultraSide3Small from './Images/ultra-3-small.webp'
import ultra1Big from './Images/ultra-1.webp'
import ultra2Big from './Images/ultra-2.webp'
import ultra3Big from './Images/ultra-3.webp'

import missionIcon from './Images/mission.png'
import visionIcon from './Images/vision.png'

import ultraProcess1 from './Images/ultra-app-1.png'
import ultraProcess2 from './Images/ultra-app-2.png'
import ultraProcess3 from './Images/ultra-app-3.png'
import ultraProcess4 from './Images/ultra-app-4.png'

import proProcess1 from './Images/pro-app-1.png'
import proProcess2 from './Images/pro-app-2.png'
import proProcess3 from './Images/pro-app-3.png'
import proProcess4 from './Images/pro-app-4.png'

import gripProcess1 from './Images/grip-app-1.png'
import gripProcess2 from './Images/grip-app-2.png'
import gripProcess3 from './Images/grip-app-3.png'
import gripProcess4 from './Images/grip-app-4.png'

import exportIcon from './Images/export-icon.png'
import packageIcon from './Images/packaging-icon.png'

import exportImg from './Images/export-img.webp'
import packageImg from './Images/packaging-img.webp'

import exportIcon1 from './Images/export-icon-1.png'
import exportIcon2 from './Images/export-icon-2.png'
import exportIcon3 from './Images/export-icon-3.png'

import packIcon1 from './Images/package-icon-1.png'
import packIcon2 from './Images/package-icon-2.png'
import packIcon4 from './Images/export-icon-4.png'

export const whyChooseaData=[
    {
        icon:whyChooseIcon1,
        title:"High Bond Strength",
        desc:"Ensures secure and long-lasting tile fixing across various surfaces and conditions."
    },
     {
        icon:whyChooseIcon2,
        title:"Polymer Enriched ",
        desc:"Formulated with advanced polymers to enhance durability, flexibility, & better performance."
    },
     {
        icon:whyChooseIcon3,
        title:"Weather Resistant",
        desc:"Withstands weather conditions for reliable long-term performance indoors & outdoors."
    },
     {
        icon:whyChooseIcon4,
        title:"Faster Installation",
        desc:"Designed for smooth handling and faster, more efficient installation on-site."
    }
]

export const Applications=[
    {
        img:applicationImg1,
        title:"Residential"
    },
      {
        img:applicationImg2,
        title:"Commercial"
    },
      {
        img:applicationImg3,
        title:"Interior"
    },
      {
        img:applicationImg4,
        title:"Exterior"
    },
      {
        img:applicationImg5,
        title:"Wet-Areas"
    }
]

export const qualities=[
    {
        icon:qualityIcon1,
        title:"Superior Bonding"
    },
     {
        icon:qualityIcon2,
        title:"Built for Durability"
    },
     {
        icon:qualityIcon3,
        title:"Multi-Application Solutions"
    }
]

export const testimonials=[
     {
    id: 1,
    name: "Rajesh Patel",
    role: "Civil Contractor",
    image: testimonialImg1,
    desc: "VigoFlex adhesives have been extremely reliable across our projects. The bonding strength is excellent, and application is smooth, which saves us both time and effort on-site."
  },
  {
    id: 2,
    name: "Amit Shah",
    role: "Tile Installer",
    image: testimonialImg2,
    desc: "We’ve used VigoFlex for multiple residential and commercial sites. The consistency and durability of the products make them a dependable choice for long-term performance."
  },
  {
    id: 3,
    name: "Imran Sheikh",
    role: "Tile Installer",
    image: testimonialImg3,
    desc:"Easy to work with and delivers strong adhesion every time. VigoFlex gives us confidence that tiles stay perfectly in place, even in high-traffic areas, making our work more efficient and reliable."
  },
     {
    id: 1,
    name: "Rajesh Patel",
    role: "Civil Contractor",
    image: testimonialImg1,
    desc: "VigoFlex adhesives have been extremely reliable across our projects. The bonding strength is excellent, and application is smooth, which saves us both time and effort on-site."
  },
  {
    id: 2,
    name: "Amit Shah",
    role: "Tile Installer",
    image: testimonialImg2,
    desc: "We’ve used VigoFlex for multiple residential and commercial sites. The consistency and durability of the products make them a dependable choice for long-term performance."
  },
  {
    id: 3,
    name: "Imran Sheikh",
    role: "Tile Installer",
    image: testimonialImg3,
    desc:"Easy to work with and delivers strong adhesion every time. VigoFlex gives us confidence that tiles stay perfectly in place, even in high-traffic areas, making our work more efficient and reliable."
  },
]

export const products = [
    {
      title: "Grip Bond",
      path: "/grip-bond",
      metaTitle:"Grip Bond: Interior Floor Tile Adhesive | VigoFlex",
      metaDesc:"Shop Grip Bond by VigoFlex for interior floors. Best for ceramic tiles, offering excellent workability and strong bonding at the most affordable price.",
      desc: "Strong bonding solution designed specifically for interior floor tiles.",
      features: ["Interior Floors", "High Adhesion", "Smooth Finish"],
      img:gripBondImg, 
      mainImg:gripMain,// Replace with your image
      theme: "card-blue",   
      IntroSubHeading:"VigoFlex - Grip Bond",
      IntroHeading:"Strong Bonding for Interior Floor Applications",
      IntroText:"Grip Bond is a premium-quality tile adhesive designed specifically for interior floor applications, delivering strong and consistent bonding for a variety of tile types. Engineered with advanced polymer technology, it provides excellent grip, durability, and ease of application, making it ideal for residential and light commercial spaces. Built to withstand regular foot traffic and everyday indoor conditions, Grip Bond ensures stable performance, smooth workability, and accurate tile placement. Its reliable formulation supports long-lasting results, making it a trusted choice for professionals focused on efficiency and dependable outcomes.",
      IntroText2:"Interior Applications | Floor Only | Strong & Stable Bonding",
      IntroPoints:[
        "Interior floors, small & medium tiles",
        "Suitable Mainly for floor applications",
        "Designed for interior applications",
        "For professionals and contractors"
      ],
      smallImg:gripSmall,
      sideSmallImg1:gripSide1Small,
      sideSmallImg2:gripSide2Small,
      sideSmallImg3:gripSide3Small,
      bigImg1:grip1Big,
      bigImg2:grip2Big,
      bigImg3:grip3Big,
      whyChooseHeading:"Built for Strength. Designed for Stability.",
      whyChooseDesc:"Grip Bond is formulated with advanced polymer technology to deliver strong bonding and consistent performance for interior floor applications. It is designed to handle everyday conditions with ease, ensuring durability, stability, and smooth application for accurate tile installation.",
      whyChoosePoints:[
        "Strong bonding strength for secure and reliable tile fixing",
        "Stable performance for interior floor applications",
        "Smooth workability for easy and efficient application",
        "Long-lasting durability for consistent and dependable results"
      ],
      headingClass: "heading-blue",
      process:[
        {
        img:gripProcess1,
        title:"Surface Preparation",
        desc:"Ensure the substrate is clean, level, and free from dust, oil, grease, or loose materials. Lightly dampen dry or absorbent surfaces prior to adhesive application."
        },
        {
        img:gripProcess2,
        title:"Mixing",
        desc:"Combine adhesive powder with clean water in the specified ratio. Mix to lump-free consistency. Allow to stand for 5 minutes, then remix before use."
        },
        {
        img:gripProcess3,
        title:"Application",
        desc:"Spread adhesive evenly with a notched trowel (3–6 mm bed). Press tiles firmly within 15–20 min and adjust alignment within 10 min."
        },
        {
        img:gripProcess4,
        title:"Curing",
        desc:"Protect the newly fixed tiles from foot traffic for at least 24 hours. Grouting and final finishing can be carried out after the curing period is complete."
        }
      ],
      faqs:[
        {
          question:"Where can Grip Bond be used?",
          answer:"Grip Bond is designed for interior floor applications, making it ideal for areas like living rooms, bedrooms, and other indoor spaces with regular foot traffic."
        },
         {
          question:"Is Grip Bond suitable for wall tiles?",
          answer:"Grip Bond is recommended specifically for floor applications. For wall or combined wall and floor use, Pro Bond is a more suitable option."
        },
         {
          question:"What tile sizes can be used with Grip Bond?",
          answer:"Grip Bond works best with small to medium-sized tiles, providing strong grip and stable support for everyday interior flooring needs."
        },
         {
          question:"Is Grip Bond easy to apply?",
          answer:"Yes, Grip Bond offers smooth workability, allowing for easy mixing, application, and tile placement, making it efficient for professionals and contractors."
        }
      ]
    },
    {
      title: "Pro Bond",
      path: "/pro-bond",
      metaTitle:"Pro Bond : High-Strength Adhesive for Vitrified Tiles | VigoFlex",
      metaDesc:"VigoFlex Pro Bond provides superior grip for interior walls and floors. Ideal for vitrified tiles in residential and commercial projects across India.",
      desc: "Versatile adhesive ideal for interior walls and floor applications.",
      features: ["Interior Walls & Floors", "Flexible & Durable", "Easy To Apply"],
      img: proBondImg, 
      mainImg:proMain,// Replace with your image
      theme: "card-black",
      IntroSubHeading:"VigoFlex - Pro Bond",
      IntroHeading:"Reliable Adhesion for Interior Walls & Floors",
      IntroText:"Pro Bond is a premium-grade tile adhesive designed for interior wall and floor applications, delivering strong, consistent bonding across a variety of surfaces. Engineered with advanced polymer technology, it offers the perfect balance of strength, flexibility, and ease of application, making it ideal for both residential and commercial spaces. Built to handle daily wear and varying indoor conditions, Pro Bond ensures durable performance, smooth workability, and precise tile installation. Its reliable formulation supports long-lasting results, making it a dependable choice for professionals seeking efficiency and quality on every project.",
      IntroText2:" Interior Applications | Wall & Floor | Flexible & Reliable Bonding",
      IntroPoints:[
        "Interior walls & floors, medium–large tiles.",
        "Suitable for both walls and floors",
        "Designed for interior applications",
        "For professionals and contractors"
      ],
       smallImg:proSmall,
      sideSmallImg1:proSide1Small,
      sideSmallImg2:proSide2Small,
      sideSmallImg3:proSide3Small,
      bigImg1:pro1Big,
      bigImg2:pro2Big,
      bigImg3:pro3Big,
      whyChooseHeading:"Built for Reliability. Designed for Versatility.",
      whyChooseDesc:"Pro Bond is formulated with advanced polymer technology to deliver strong bonding and consistent performance across interior wall and floor applications. It is designed to handle everyday conditions with ease, ensuring durability, flexibility, and smooth application for precise tile installation.",
      whyChoosePoints:[
        "Strong bonding strength for secure and reliable tile fixing",
        "Flexible performance for interior walls and floor applications",
        "Smooth workability for easy and efficient application",
        "Long-lasting durability for consistent and dependable results"
      ],
      headingClass: "heading-black",
      process:[
        {
        img:proProcess1,
        title:"Surface Preparation",
        desc:"Ensure the substrate is clean, level, and free from dust, oil, grease, or loose materials. Lightly dampen dry or absorbent surfaces prior to adhesive application."
        },
        {
        img:proProcess2,
        title:"Mixing",
        desc:"Combine adhesive powder with clean water in the specified ratio. Mix to lump-free consistency. Allow to stand for 5 minutes, then remix before use."
        },
        {
        img:proProcess3,
        title:"Application",
        desc:"Spread adhesive evenly with a notched trowel (3–6 mm bed). Press tiles firmly within 15–20 min and adjust alignment within 10 min."
        },
        {
        img:proProcess4,
        title:"Curing",
        desc:"Protect the newly fixed tiles from foot traffic for at least 24 hours. Grouting and final finishing can be carried out after the curing period is complete."
        }
      ],
      faqs:[
        {
          question:"Where can Pro Bond be used?",
          answer:"Pro Bond is designed for interior applications, making it ideal for both walls and floors in residential and commercial spaces such as living rooms, kitchens, and offices."
        },
         {
          question:"Is Pro Bond suitable for both walls and floors?",
          answer:"Yes, Pro Bond is formulated for dual application, providing strong adhesion and flexibility for both wall and floor tiling within interior environments."
        },
         {
          question:"Can Pro Bond handle medium and large tiles?",
          answer:"Yes, Pro Bond works well with medium to large tiles, offering reliable bonding strength and stability for proper tile placement and long-term performance."
        },
         {
          question:"Is Pro Bond easy to apply?",
          answer:"Pro Bond is designed for smooth and easy application, ensuring good workability and efficient installation for professionals and contractors."
        }
      ]
    },
    {
      title: "Ultra Bond",
      path: "/ultra-bond",
      metaTitle:"Ultra Bond : Exterior & Large Format Tile Adhesive India | VigoFlex",
      metaDesc:"Heavy-duty Ultra Bond for exterior walls and large tiles. Weather-resistant, high-polymer adhesive designed for India’s demanding climate conditions.",
      desc: "High-performance adhesive for all surfaces, including exterior areas.",
      features: ["Interior & Exterior", "High Performance", "All Surface Usage"],
      img: ultraBondImg, 
      mainImg:ultraMain,// Replace with your image
      theme: "card-red",
      IntroSubHeading:"VigoFlex - Ultra Bond",
      IntroHeading:"High-Performance Adhesive for Every Surface",
      IntroText:"Ultra Bond is a high-performance tile adhesive designed for both interior and exterior applications, delivering strong and reliable bonding for walls and floors. Engineered for superior versatility and durability, it ensures consistent performance across a wide range of surfaces and varying site conditions. Ideal for residential and commercial use, Ultra Bond offers high strength, easy application, and excellent workability, helping achieve precise installation with minimal effort. Its advanced formulation supports long-lasting results, enhanced adhesion, and dependable performance for every tiling project, regardless of scale or complexity.",
      IntroText2:"Interior & Exterior | Wall & Floor | High Strength",
      IntroPoints:[
        "Exterior areas, large tiles, heavy-duty applications",
        "Suitable for both walls and floors",
        "Suitable for both interior and exterior applications.",
        "For professionals and contractors"
      ],
      smallImg:ultraSmall,
      sideSmallImg1:ultraSide1Small,
      sideSmallImg2:ultraSide2Small,
      sideSmallImg3:ultraSide3Small,
      bigImg1:ultra1Big,
      bigImg2:ultra2Big,
      bigImg3:ultra3Big,
      whyChooseHeading:"Built for Strength. Designed for Performance.",
      whyChooseDesc:"Ultra Bond is formulated with advanced polymer technology to deliver exceptional bonding strength and long-term durability. It is designed to perform in demanding conditions, including exterior environments and high-traffic areas.",
      whyChoosePoints:[
        "Superior bonding strength for secure and reliable tile fixing",
        "Weather-resistant performance for indoor & outdoor durability",
        "Ideal for large tiles with strong grip and stable support",
        "Long-lasting durability for consistent and dependable results"
      ],
      headingClass: "heading-red",
      process:[
        {
        img:ultraProcess1,
        title:"Surface Preparation",
        desc:"Ensure the substrate is clean, level, and free from dust, oil, grease, or loose materials. Lightly dampen dry or absorbent surfaces prior to adhesive application."
        },
        {
        img:ultraProcess2,
        title:"Mixing",
        desc:"Combine adhesive powder with clean water in the specified ratio. Mix to lump-free consistency. Allow to stand for 5 minutes, then remix before use."
        },
        {
        img:ultraProcess3,
        title:"Application",
        desc:"Spread adhesive evenly with a notched trowel (3–6 mm bed). Press tiles firmly within 15–20 min and adjust alignment within 10 min."
        },
        {
        img:ultraProcess4,
        title:"Curing",
        desc:"Protect the newly fixed tiles from foot traffic for at least 24 hours. Grouting and final finishing can be carried out after the curing period is complete."
        }
      ],
      faqs:[
        {
          question:"Where can Ultra Bond be used?",
          answer:"Ultra Bond is suitable for both interior and exterior applications, including walls and floors. It is ideal for outdoor areas, balconies, terraces, and high-traffic zones where strong and durable bonding is required."
        },
         {
          question:"Is Ultra Bond suitable for large tiles?",
          answer:"Yes, Ultra Bond is designed to handle large-format tiles. Its high bonding strength ensures proper adhesion and reduces the risk of tile displacement, even under heavy load conditions."
        },
         {
          question:"Can Ultra Bond withstand weather conditions?",
          answer:"Absolutely. Ultra Bond offers excellent weather resistance, making it suitable for exterior surfaces exposed to heat, moisture, and varying environmental conditions."
        },
         {
          question:"How much area does one bag cover?",
          answer:"Coverage depends on tile size and surface condition, but a 20kg bag typically covers a standard area under normal application conditions. For accurate estimation, it’s recommended to use the coverage calculator on the website."
        }
      ]
    }
  ];

export const missionVision=[
  {
    icon:visionIcon,
    title:"Our Vision",
    desc:"To become a trusted name in tile adhesive solutions by delivering consistent quality, innovative formulations, and long-lasting performance across every project."
  },
  {
    icon:missionIcon,
    title:"Our Mission",
    desc:"To provide high-performance tile adhesives that ensure strong bonding, ease of application, and reliable results supporting professionals in achieving durable and efficient installations."
  }
]

export const comparisonData = [
  {
    feature: "Best For",
    grip: "Interior floors as well as small–medium tiles",
    pro: "Interior walls & floors, medium–large tiles",
    ultra: "Exterior areas, large tiles, heavy-duty projects"
  },
  {
    feature: "Suitable Surfaces",
    grip: "Floor only",
    pro: "Walls & Floors",
    ultra: "Walls & Floors"
  },
  {
    feature: "Application Type",
    grip: "Interior",
    pro: "Interior",
    ultra: "Interior & Exterior"
  },
  {
    feature: "Strength Level",
    grip: "Strong",
    pro: "Strong & Flexible",
    ultra: "Maximum Strength"
  },
  {
    feature: "Tile Size",
    grip: "Small to Medium",
    pro: "Medium to Large",
    ultra: "Large Format Tiles"
  },
  {
    feature: "Weather Resistance",
    grip: "Not Required",
    pro: "Moderate (Indoor Use)",
    ultra: "High (Exterior Ready)"
  },
  {
    feature: "Workability",
    grip: "Easy application",
    pro: "Smooth & Flexible",
    ultra: "Advanced / Professional Application"
  },
  {
    feature: "Durability",
    grip: "Reliable for daily indoor use",
    pro: "Durable for varied interior conditions",
    ultra: "Long-lasting in extreme conditions"
  },
  {
    feature: "Skill Level",
    grip: "Professionals",
    pro: "Professionals",
    ultra: "Professionals / Contractors"
  },
  {
    feature: "Ideal Use Case",
    grip: "Residential flooring",
    pro: "Residential & commercial interiors",
    ultra: "Commercial, high-traffic areas"
  }
];

export const exportData=[
  {
  icon:exportIcon,
  heading:"Export Capabilites",
  subheading:"Delivering Quality across borders",
  img:exportImg,
  points:[
    {
    icon:exportIcon1,
    title:"Global Reach",
    desc:"Supplying to markets across Asia, Middle East, Africa, Europe & Beyond"
    },
     {
    icon:exportIcon2,
    title:"Bulk Supply",
    desc:"High production capacity to meet the demands of large-scale projects."
    },
     {
    icon:exportIcon3,
    title:"Consistent Quality",
    desc:"International quality standards maintained in every shipment."
    },
  ]
  },
  {
  icon:packageIcon,
  heading:"Customized Packing Options",
  subheading:"Packaging that represents your brand",
  img:packageImg,
  points:[
    {
    icon:packIcon1,
    title:"Multiple Sizes",
    desc:"Available in various multiple size and bulk packing as per need."
    },
     {
    icon:packIcon2,
   title: "Flexible Packing",
desc: "Multiple packing options available for retail, commercial, and bulk requirements."
    },
     {
    icon:packIcon4,
    title:  "Export Packaging",
desc: "Secure packaging designed for safe storage, transportation, and export handling."
    }
  ]
  }
]